import api from "./api";

const NotificationAPI = {
    getByUserId: (statusId) => api.get(`/user/notifications/read-status/${statusId}`),
    getUserSettings: (userId) => api.get(`/user/notifications/user-settings/${userId}`),
    insUpdUserSetting: (data) => api.post(`/user/notifications/user-settings`, data),
    markAsRead: (notificationId) => api.post(`/user/notifications/mark-read`, { notificationId }),
};

export default NotificationAPI;